<!-- WarningMessage.vue -->
<template>
  <div class="warning-message">
    <slot>{{ message }}</slot>
  </div>
</template>

<script>
export default {
  name: 'WarningMessage',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.warning-message {
  background-color: #fff3e0;
  color: #e65100;
  padding: 12px 16px;
  margin-top: 16px;
  border-left: 4px solid #ff9800;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.warning-message::before {
  content: '⚠️';
  margin-right: 8px;
  font-size: 18px;
}
</style>
